export default class DateFilterService {
  /**
   * UTC offset from local time
   * @return Number
   */
  static utcTimeOffset() {
    let d = new Date();
    return d.getTimezoneOffset();
  }

  /**
   * Some API methods require OddFormat to be specified with an ID
   * This mostly applies to old API endpoints
   */
  static convertOddFormatStringToId(oddFormatString) {
    switch (oddFormatString) {
      case 'decimal':
        return 0;
      case 'fractional':
        return 1;
      case 'american':
        return 2;
      default:
        return null;
    }
  }

  /**
   * Date Filter Validator for old API
   * (Used in: Top Winnings widget)
   * @param  dateFilter route date filter value
   * @return Number
   */
  static parseOldAPIDateFilter(dateFilter) {
    let newDateFilter;
    switch (dateFilter) {
      case '1-day':
        newDateFilter = 1;
        break;
      case '7-days':
        newDateFilter = 2;
        break;
      case '30-days':
        newDateFilter = 3;
        break;
      default:
        newDateFilter = 0;
    }
    return newDateFilter;
  }

  /**
   * Date Filter Validator
   * @param  dateFilter route date filter value
   * @return Number
   */
  static parseDateFilter(dateFilter) {
    let newDateFilter = 0;
    switch (dateFilter) {
      case '1-day':
        newDateFilter = 1;
        break;
      case '2-days':
        newDateFilter = 2;
        break;
      case '3-days':
        newDateFilter = 3;
        break;
      case '7-days':
        newDateFilter = 7;
        break;
      case '24-hour':
        newDateFilter = 24;
        break;
      default:
        newDateFilter = 0;
    }
    return newDateFilter;
  }

  /**
   * Format date/time, or both in local datetime
   * @param {string} dateTime date time string
   * @param {'date'|'time'|'datetime'} returnType enum: date|time|datetime
   * @param {string} dateFormat string for the date display  example mm/dd/yyyy
   * @param {string} timeFormat string for the time display  example 'hh:ii' hh for 24 hour time, HH for 12 hour time
   * @param {boolean} [isUtc] bool if input datetime string is UTC
   * @param {number} [offset] - Optional time offset
   * @param {string} [dateTimeSeparator] - Optional separator between date time
   * @return formated string of local date|time
   */
  static localDate(dateTime, returnType, dateFormat, timeFormat, isUtc = true, offset, dateTimeSeparator = ' ') {
    if (!dateTime) {
      return '';
    }

    // create new local date from string date
    let localDate = DateFilterService.convertToDateTime(dateTime, isUtc);
    if (offset) {
      let offsetValue = localStorage.getItem('timezone');
      // eslint-disable-next-line
      if (offsetValue !== undefined && offsetValue != 0) {
        localDate.setTime(localDate.getTime() + (offsetValue * 60 * 60 * 1000));
      }
    }

    function addZero(i) {
      if (i < 10) {
        i = `0${i}`;
      }
      return i;
    }

    // get date components, year, month, day, hour 24, hour 12, minute, ap|pm
    let mm = `0${localDate.getMonth() + 1}`.substr(-2);
    let dd = `0${localDate.getDate()}`.substr(-2);
    let yyyy = localDate.getFullYear();
    let yy = localDate.getFullYear().toString().substring(2, 4);
    let hh = `0${localDate.getHours()}`.substr(-2);
    let ii = `0${localDate.getMinutes()}`.substr(-2);
    const ss = addZero(localDate.getSeconds());
    let HH = localDate.getHours();
    let ampm = HH >= 12 ? 'PM' : 'AM';
    if (HH > 12) {
      HH -= 12;
      HH = `0${HH}`.substr(-2);
    } else if (HH === 0) {
      HH = 12;
    }
    // if requested date format is:
    let dateTimeFormat = '';
    let dateF = typeof dateFormat !== 'undefined' ? dateFormat : APP_SETTINGS.formatting.shortDateFormat; // eslint-disable-line
    let timeF = typeof timeFormat !== 'undefined' ? timeFormat : APP_SETTINGS.formatting.shortTimeFormat; // eslint-disable-line
    switch (returnType) {
      case 'date':
        dateTimeFormat = dateF;
        break;
      case 'time':
        dateTimeFormat = timeF;
        break;
      default:
        dateTimeFormat = `${dateF}${dateTimeSeparator}${timeF}`;
        break;
    }
    return dateTimeFormat
      .replace('dd', dd)
      .replace('mm', mm)
      .replace('yyyy', yyyy)
      .replace('yy', yy)
      .replace('hh', hh)
      .replace('HH', HH)
      .replace('ii', ii)
      .replace('ss', ss)
      .replace('ampm', ampm);
  }

  /**
   * convertToDateTime converts string to javascript date object
   * @param dateTime date time string
   * @param isUtc boolean, if input datetime is utc or local format
   * @return Date
   */
  static convertToDateTime(dateTime, isUtc = true) {
    let tmpDate;
    // split string datetime into date and time string, and then into day, month, year, hour and minute.
    if (dateTime.indexOf('T') < 0) {
      tmpDate = dateTime.split(' ');
    } else {
      tmpDate = dateTime.split('T');
    }
    let date = tmpDate[0].split('-');
    let time = tmpDate[1].split(':');
    // create javascript date object from datetime string parts
    let lYear = Number.parseInt(date[0], 10);
    let lMonth = Number.parseInt(date[1], 10) - 1;
    let lDay = Number.parseInt(date[2], 10);
    let lHours = Number.parseInt(time[0], 10);
    let lMinutes = Number.parseInt(time[1], 10);
    let lSeconds = Number.parseInt(time[2], 10) || 0;
    let localDate = new Date(lYear, lMonth, lDay, lHours, lMinutes, lSeconds);
    if (isUtc) {
      localDate = new Date(Date.UTC(lYear, lMonth, lDay, lHours, lMinutes, lSeconds));
    }
    // return back the date objects
    return localDate;
  }

  /**
   * Get the unix timestamp for a given utc date time string
   * @param {String} dateTime
   */
  static getTimeStamp(dateTime) {
    let date = new Date();
    let UTCdateTime = dateTime;
    if (UTCdateTime.indexOf(' ') > -1) {
      UTCdateTime.replace(' ', 'T');
    }
    if (UTCdateTime.indexOf('Z') === -1) {
      UTCdateTime = `${UTCdateTime}Z`;
    }
    return date.getTime(UTCdateTime);
  }
}
